import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '@emotion/react'
import { Theme, Outer, Inner } from './style.js';
import { Box, Loading } from 'components';
import { Siderbar } from '../components';
import { Alert } from 'components';

function Default() {
  return (
    <ThemeProvider theme={Theme}>
      <Box display="flex">
        <Siderbar />
        <Outer>
          <Inner>
            <Outlet />
          </Inner>
        </Outer>
        <Alert left={240} />
        <Loading />
      </Box>
    </ThemeProvider>
  );
}

export default Default;
